import React, { useState, useEffect, useRef, useDebugValue } from "react";
import { NumericTextBox } from '@progress/kendo-react-inputs';
import moment from "moment";
import { SBGrid } from "../../UiComponents/SBAAGgrid";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { UrlPath } from "../../../config/routeConfig";
import { TopBar } from '../../shared/topBar/TopBar';
import { useDispatch, useSelector } from 'react-redux';
import { SBADropDown, SBAMultiSelectCheck, SBAComboBox } from "../../UiComponents/SBADropDown";
import { sbaAxios } from "../../utils/sbaAxios";
import { SBACurrencyInput } from "../../UiComponents/SBACurrencyInput";
import {
    getAllCustomViews,insertOrUpdatePipeline, getPipelineType, getPipelineSize, getPipelineStage, insertPipelineCustomviewSettings,
    getPipelineStatus, getPiplelineTransactionType, getProbability, getPipeline, getSelectedCustomView,getPipelineSummarydata,
    getCustomViewColumnAvailable, getCustomViewSettings, getCustomSettings, deleteCustomView, updateCustomViewName,getPipelineCompanyContact,getInvestorActivities,getActivityDetails,DownloadDocument,getPipelineOwners,deletePipeline,getUserPageAccess, getContacts
} from "../../../config/apiConfig";
import { getPipelineAction } from "../../actions/pipelineAction"
import { LoadingScreen } from "../../UiComponents/LoadingComponent";
import { SBADrawer } from "../../UiComponents/SBADrawer";
import { AgGridReact } from "ag-grid-react";
import { getAllUsers } from "../../actions/UserAction";
import { Column } from "ag-grid-community";
import { SBNotify } from "../../utils/sbNotify";
import { SBDatePicker } from "../../UiComponents/SBDatePicker";
import { Modal } from "react-bootstrap";
import Form from 'react-bootstrap/Form';
import { exportToExcelUsingRef } from '../../utils/excelExporter';
import download from "../../../Images/download.svg"
import { ToastContainer } from "react-toastify";
import { currencyFormatter} from "../../transactions/utils";
import { Splitter } from "@progress/kendo-react-layout";
import { Tooltip } from "react-tooltip";
import { Link } from "react-router-dom";
import { useMemo } from "react";
export const Opportunities = () => {
    const removeDrawerTabIndex = () => {
        const drawers = document.getElementsByClassName('rs-drawer-wrapper');
        Array.from(drawers).forEach(drawer => {
          drawer.removeAttribute('tabIndex');
        });
      };
      removeDrawerTabIndex();
    
    const dispatch = useDispatch();
    const [pipelinedatas, setpipelinedata] = useState(pipelinedata);
    const [render,setRender]=useState(0);
    const [opportunityDeleteAccess,setOpportunityDeleteAccess]=useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [selectedView, setSelectedView] = useState([]);
    const [pipelineId,setpipelineId]=useState();
    useEffect(() => {
        document.title = "Opportunities";
        getopportunitiesDeleteAccess();      
        dispatch(getPipelineAction(pipelinedatas));
        GetPipeline(pipelinedatas);
        dispatch(getAllUsers());
        GetCustomViewColumnAvailable(null);
        GetStatusSetting(selectedView.CustomViewID);
        LoadSummaryText('1,4,5');
        GetStatusSettingSort(selectedView.CustomViewID);
        GetsettingNames(selectedView.CustomViewID);
        getOwners();
        fetchGridData();
    }, [opportunityDeleteAccess]);

    useEffect(() => {
        if (selectedView)
            Selectedcolumndata(selectedView.CustomViewID);
    }, [selectedView]);

    useEffect(()=>{
        GetEnterPipeline({
            statusIdList: selectstatusId !== 0 ? selectstatusId : "1,4,5",
            probabilityIdList: null,
            stageIdList: null,
            typeIdList: null,
            isInsuranceList: null,
            sizeIdList: null,
            contactSourceList: null,
            sbaOwnerList: null
        });
        GetAllCustomViews(render === 0 ? 0 : selectedCustomViewData);
        enterclick();
        LoadSummaryText('1,4,5');
    }, [render]);
    const Gstate = useSelector(state => { return state; }) || {};
    const GridPipelinedata = Gstate.Pipelinedata.Pipelinedata || {};
    const users = useSelector((state) => state.Users.Users);
    const availablecolumnRef = useRef();
    const selectedViewcolumnApi = useRef();
    const sortcolumnApi = useRef();

    const [CustomViedata, setCustomViedata] = useState([]);
    const [selectedCustomViewData, setSelectedCustomViewData] = useState([]);
    const [Probability, setProbability] = useState([]);
    const [ProbabilityId, setProbabilityId] = useState([]);
    const [SelectedProbability, setSelectedProbability] = useState([]);
    const [stage, setstage] = useState([]);
    const [stageId, setstageId] = useState([]);
    const [Type, setType] = useState([]);
    const [TypeId, setTypeId] = useState([]);
    const [Size, setSize] = useState([]);
    const [SizeId, setSizeId] = useState([]);
    const [availablecolumn, setavailablecolumn] = useState([]);
    const [selectablecolumn, setselectablecolumn] = useState([]);
    const [GridData, setGridData] = useState([]);
    const [showView, setshowView] = useState(false);
    const [tooltipData, settooltipData] = useState([]);
    const [InsuranceId, setInsuranceId] = useState([]);
    const [Source, setSource] = useState([]);
    const [SourceId, setSourceId] = useState([]);
    const [Owner, setOwner] = useState([{
        "UserId": -1,
        "setOwner": "All"
    }]);
    const [OwnerId, setOwnerId] = useState([]);
    const [IncludeStatus, setIncludeStatus] = useState(IncludeStatusplain);
    const [column, setselectedcolumn] = useState([]);
    const [selectstatusId, setselectstatusId] = useState([]);
    const [selectsortvalue, setselectsortvalue] = useState([]);
    const [appliedFilter, setAppliedFilter] = useState({});
    const GridRef = useRef();

    const [selectsortorder, setselectsortorder] = useState([]);
    const [gridsortorder, setgridsortorder] = useState([]);
    const [showAddView, setshowAddView] = useState(false);
    const [Renamemodal, setRenamemodal] = useState(false);
    const [titleName, setTitleName] = useState();
    const [updateViewName, setUpdateViewName] = useState('');
    const [showdeleteviewModal, setShowdeleteviewModal] = useState(false);

    const [mode, setmode] = useState(); 
    const [createAddEditDrawer, setCreateAddEditDrawer] = useState(false);
    const [opportunitiesData,SetOpportunitiesData]=useState([PlainopportunitiesData]);
    const [summaryData,setSummarydata]=useState();
    const [pipelineValue,setPipelineValue]=useState();
    const [contactnotes,setContactNotes]=useState([]);
    const [probabilityselected, setProbabilityselected] = React.useState({ value: Probability, allSelected: true });
    const [stageselected, setStageselected] = React.useState({ value: stage, allSelected: true });
    const [typeselected, setTypeselected] = React.useState({ value: Type, allSelected: true });
    
    const [sizeselected, setSizeselected] = React.useState({ value: Size, allSelected: true });
    const [sourceselected, setSourceselected] = React.useState({ value: Source, allSelected: true });
    const [ownerselected, setOwnerselected] = React.useState({ value: Owner, allSelected: true });
    const SortOrderData = [

        {
            "SortId": 1,
            "SortName": "Asc"
        },
        {
            "SortId": 2,
            "SortName": "Desc"
        },

    ]

    const avalicoldef = [
      
        {
            field: "headerName",
            headerName: "Column",
        },  

    ];
   
    const sortcolumnDefs = [{
        field: "SortBy",
        headerName: "Sort By",
    },
        {
            field: "SortOrder",
            headerName: "Sort Order",
        },
    ]

    const Insurance = [{
        "InsuranceId": -1,
        "InsuranceName": "All"
          },
        { "InsuranceId": 1,
        "InsuranceName": "Yes"
        },
        {
            "InsuranceId": 2,
            "InsuranceName": "No"
        },
    ]
    const [insuranceselected, setInsuranceselected] = React.useState({ value: Insurance, allSelected: true });
    const [panes, setPanes] = React.useState([{
        size: '70%',
        min: '20px',
        collapsible: true
    }, {}, {
        size: '20%',
        min: '20px',
        collapsible: true
    }]);
    const onChange = event => {
        setPanes(event.newState);
    };
    const getopportunitiesDeleteAccess = async  () => {
        try {
          const opportunitydeleteAccessPromise = sbaAxios({ url: `${getUserPageAccess}?keyName=OpportunitiesDeleteAccess` });
         
          const [
           
            
            opportunitydeleteAccessResponse,
           
          ] = await Promise.all([
            
            opportunitydeleteAccessPromise
          ]);
         
          
          setOpportunityDeleteAccess(opportunitydeleteAccessResponse);
        } catch (error) {
          console.error("An error occurred:", error);
          
        }
      };
    const GetEnterPipeline = async (data) => {

        try {
            const response = await sbaAxios({
                url: `${getPipeline}`,
                method: 'post',
                data: data
            });
            const grdData= response.map((item) => ({
                ...item,
                "PipelineDate":item.PipelineDate ? moment(item.PipelineDate).format('MM-DD-YYYY') : "",
                "CommunicationDate":item.CommunicationDate ? moment(item.CommunicationDate).format('MM-DD-YYYY') : "",
                "ModifiedDate":item.ModifiedDate ? moment(item.ModifiedDate).format('MM-DD-YYYY') : "",
                "EstimatedCloseDate":item.EstimatedCloseDate ? moment(item.EstimatedCloseDate).format('MM-DD-YYYY') : "",
                }))
            setGridData(grdData);
        
        }
        catch (e) {
        console.log(e, 'Error Fetching the view data');
    }
    }

    const GetPipeline = async (data) => {
        try {
            const response = await sbaAxios({
                url: `${getPipeline}`,
                method: 'post',
                data: data
            });
            const grdData= response.map((item) => ({
                ...item,
                "PipelineDate":item.PipelineDate ? moment(item.PipelineDate).format('MM-DD-YYYY') : "",
                "CommunicationDate":item.CommunicationDate ? moment(item.CommunicationDate).format('MM-DD-YYYY') : "",
                "ModifiedDate":item.ModifiedDate ? moment(item.ModifiedDate).format('MM-DD-YYYY') : "",
                "EstimatedCloseDate":item.EstimatedCloseDate ? moment(item.EstimatedCloseDate).format('MM-DD-YYYY') : "",
                }))
            setGridData(grdData);
            const uniqueProbdata = [{
                "PipelineProbabilityId": -1,
                "PipelineProbilityName": "All"
            }];
            const uniqueStage = [{
                PipelineStageId: -1,
                PipelineStageName: "All"
            }];
            const uniqueType = [{
                PipelineTypeId: -1,
                PipelineTypeName: "All"
            }];
            const uniqueSize = [{
                PipelineSizeId: -1,
                PipelineSizeName: "All"
            }
            ];
            const uniqueOwner = [{
                UserId: -1,
                FullName: "All"
            }
            ];
            const uniqueSource =[{
                ContactSource: -1,
                ContactSource: "All"
            }];
           
            response.forEach(item => {        
                const probExists = uniqueProbdata.some(
                    uniqueItem => uniqueItem.PipelineProbabilityId === item.PipelineProbabilityId
                );
                const exists = uniqueProbdata.some(
                    uniqueItem => uniqueItem.PipelineProbabilityId === item.PipelineProbabilityId
                );
                const stageExists = uniqueStage.some(
                    uniqueItem => uniqueItem.PipelineStageId === item.PipelineStageId
                );
                const typeExists = uniqueType.some(
                    uniqueItem => uniqueItem.PipelineTypeId === item.PipelineTypeId
                );
                const sizeExists = uniqueSize.some(
                    uniqueItem => uniqueItem.PipelineSizeId === item.PipelineSizeId
                );
                const ownerExists = uniqueOwner.some(
                    uniqueItem => uniqueItem.UserId === item.OwnerUserId
                );
                 const sourceExists = uniqueSource.some(
                    uniqueItem => uniqueItem.ContactSource === item.ContactSource
                );
                
                if (!probExists) {
                    
                    uniqueProbdata.push({
                        "PipelineProbabilityId": item.PipelineProbabilityId,
                        "PipelineProbilityName": item.PipelineProbabilityName
                    });
                }
                if (!stageExists) {
                    if(item.PipelineStageId!=="" && item.PipelineStageName!=="")
                    {
                    uniqueStage.push({
                        PipelineStageId: item.PipelineStageId,
                        PipelineStageName: item.PipelineStageName
                    });
                }
                }

                if (!typeExists) {
                    if(item.PipelineTypeId!=="" && item.PipelineTypeName!=="")
                    {
                    uniqueType.push({
                        PipelineTypeId: item.PipelineTypeId,
                        PipelineTypeName: item.PipelineTypeName
                    });
                }
                }

                if (!sizeExists) {
                    if(item.PipelineSizeId!=="" && item.PipelineSizeName!=="")
                    {
                    uniqueSize.push({
                        PipelineSizeId: item.PipelineSizeId,
                        PipelineSizeName: item.PipelineSizeName
                    });
                }
                }

                if (!ownerExists) {
                    if(item.OwnerUserId!=="" && item.OwnerFullName!=="")
                  {
                   uniqueOwner.push({
                      UserId: item.OwnerUserId,
                      FullName: item.OwnerFullName
                    });
                }
                 }
            
        
          if (!sourceExists) {
                if(item.ContactSource!=="")
                {
                uniqueSource.push({
                    ContactSource: item.ContactSource,
                    ContactSourceId: item.ContactSource
                });
            }
            }
            });
            setProbability(uniqueProbdata);
            setSize(uniqueSize);
            setType(uniqueType);
            setstage(uniqueStage);
            setOwner(uniqueOwner);
            setSource(uniqueSource);
            setProbabilityselected({ value: uniqueProbdata, allSelected: true });
            setStageselected({ value: uniqueStage, allSelected: true});
            setTypeselected({ value: uniqueType, allSelected: true});
            setSizeselected({value:uniqueSize, allSelected: true});
           
            setSourceselected({value:uniqueSource, allSelected: true})
        } catch (e) {
            console.log(e, 'Error Fetching the view data');
        }
    };
    // Dropdown data 
    const getOwners = async () => {
        const response = await sbaAxios({
            url: `${getPipelineOwners}`,
            method: 'get',
        });
        if (response) {
            const owner = response.length > 1 ? [{
                "UserId": -1,
                "FullName": "All"
            }, ...response] : response;
            setOwner(owner);
            setOwnerselected({ value: owner, allSelected: true });
        }
    };

    const GetAllCustomViews = async (Id) => {
        try {
            const response = await sbaAxios({
                url: `${getAllCustomViews}/${433}`,
                method: 'get',
            });
            setCustomViedata(response);
            if (Id === 0) {
                const default_view = response.filter((item) => item.CustomViewName === "Default");
                setSelectedCustomViewData({ CustomViewName: default_view[0].CustomViewName, CustomViewID: default_view[0].CustomViewID });
                setSelectedView({ CustomViewName: default_view[0].CustomViewName, CustomViewID: default_view[0].CustomViewID });
                GetStatusSetting(default_view[0].CustomViewID);
                GetsettingNames(default_view[0].CustomViewID);
                GetStatusSettingSort(default_view[0].CustomViewID);
                GetSelectedCustomView(default_view[0].CustomViewID)
           }
        }
        catch (e) {
            console.log(e, 'Error Fetching the  view data')

        };
    };

    const Selectedcolumndata = async (CustomViewId) => {
        const response = await sbaAxios({
            url: `${getSelectedCustomView}/${CustomViewId}`,
            method: 'get',
        });
        if (response && response.length >0) {
            
            const mappedColumns = response.map((item) => ({
                ...item,
                headerName:
                    item.CustomViewPageColumnName === "Contact/CompanyName" ? "Contact" :
                    item.CustomViewPageColumnName === "InvestmentStatus" ? "Investment Status" :
                    item.CustomViewPageColumnName === "Stage" ? "Stage" :
                    item.CustomViewPageColumnName === "OpportunityType" ? "Opportunity Type" :
                    item.CustomViewPageColumnName === "AdditionalOpportunity" ? "Additional Opportunity" :
                    item.CustomViewPageColumnName === "Insurance" ? "Insurance" :
                    item.CustomViewPageColumnName === "Size" ? "Size" :
                    item.CustomViewPageColumnName === "OpportunityStatus" ? "Opportunity Status" :
                    item.CustomViewPageColumnName === "MinValue" ? "Min Value" :
                     item.CustomViewPageColumnName === "MaxValue" ? "Max Value" :
                    item.CustomViewPageColumnName === "Date" ? "Date" :
                    item.CustomViewPageColumnName === "TransactionType" ? "TransactionType" :
                    item.CustomViewPageColumnName === "Owner" ? "Owner" :
                   item.CustomViewPageColumnName === "EstimatedCloseDate" ? "Estimated Close Date" :
                  item.CustomViewPageColumnName === "LeadSource" ? "Lead Source" :
                 item.CustomViewPageColumnName === "LastCommunicationDate" ? "Last Communication Date" :
              item.CustomViewPageColumnName === "OpportunityStatus" ? "Opportunity Status" :
             item.CustomViewPageColumnName === "Comments" ? "Comments" :
            item.CustomViewPageColumnName === "Status" ? "Status" :
       item.CustomViewPageColumnName === "ModifiedDate" ? "Modified Date" :
      item.CustomViewPageColumnName === "ModifiedBy" ? "Modified By" :

           null
            })).filter(item=>item.CustomViewPageColumnName != "TransactionType");
            const filteredRowData = mappedColumns.filter(item => item.CustomViewPageColumnName !== "InvestmentStatus")
            setselectablecolumn(filteredRowData);
        }
        else{
            setselectablecolumn([]);
        }
    }
    //Drawer Grid Data loaded
    const GetCustomViewColumnAvailable = async (CustomViewId) => {
        try {
            const response = await sbaAxios({
                url: `${getCustomViewColumnAvailable}/${CustomViewId},${433}`,
                method: 'get',
            });

            // Correctly map the response to a new array
            const mappedColumns = response.map((item) => ({
                ...item,
                headerName:
                    item.CustomViewPageColumnName === "Contact/CompanyName" ? "Contact" :
                        item.CustomViewPageColumnName === "InvestmentStatus" ? "Investment Status" :
                            item.CustomViewPageColumnName === "Stage" ? "Stage" :
                            item.CustomViewPageColumnName === "Status" ? "Status" :
                                item.CustomViewPageColumnName === "OpportunityType" ? "Opportunity Type" :
                                    item.CustomViewPageColumnName === "AdditionalOpportunity" ? "Additional Opportunity" :
                                        item.CustomViewPageColumnName === "Insurance" ? "Insurance" :
                                            item.CustomViewPageColumnName === "Size" ? "Size" :
                                            item.CustomViewPageColumnName === "Comments" ? "Comments" :
                                            item.CustomViewPageColumnName === "ModifiedBy" ? "Modified By" :
                                            item.CustomViewPageColumnName === "ModifiedDate" ? "Modified Date" :
                                            item.CustomViewPageColumnName === "LastCommunicationDate" ? "Last Communication Date" :
                                                item.CustomViewPageColumnName === "OpportunityStatus" ? "Opportunity Status" :
                                                    item.CustomViewPageColumnName === "MinValue" ? "Min Value" :
                                                        item.CustomViewPageColumnName === "MaxValue" ? "Max Value" :
                                                            item.CustomViewPageColumnName === "Date" ? "Date" :
                                                                item.CustomViewPageColumnName === "TransactionType" ? "TransactionType" :
                                                                    item.CustomViewPageColumnName === "Owner" ? "Owner" :
                                                                        item.CustomViewPageColumnName === "EstimatedCloseDate" ? "Estimated Close Date" :
                                                                            item.CustomViewPageColumnName === "LeadSource" ? "Lead Source" :
                                                                                null
            })).filter(item=>item.CustomViewPageColumnName != "TransactionType");
            const filteredRowData = mappedColumns.filter(item => item.CustomViewPageColumnName !== "InvestmentStatus")
            // Set state with the mapped result
            setavailablecolumn(filteredRowData);
        } catch (error) {
            console.error("Error in GetCustomViewColumnAvailable:", error);
        }
    };

    const ActionButtonRenderer = (props) => {
        const handleDeleteClick = () => {
              setpipelineId(props.data.PipelineId);
             
              setDeleteModal(true);
            
          }
            return <>  <i className={"fas fa-edit"} style={{ color: "#47A547", margin: "0 8px", cursor: "pointer" }} onClick={()=>{setCreateAddEditDrawer(true); setmode("Edit");SetOpportunitiesData(props.data)}}></i>
        
           {opportunityDeleteAccess && <i className="fa fa-trash" style={{ color: "red" , margin: "0 8px", cursor: "pointer" }} onClick={handleDeleteClick}></i>}
         </>
           
            
              
    }
    const FormatCurrencyGrid = (value) => {
        if (value === undefined || value === null){
            return null;
        }
        const num = Number(value);
        if (!isNaN(num)) {
            const isNegative = num < 0;

            const formattedValue = isNegative
                ? `($${Math.abs(num).toLocaleString('en-US', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                })})`
                : `$${num.toLocaleString('en-US', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                })}`;
            const style = isNegative ? { color: 'red' } : null;

            return <span style={style}>{formattedValue}</span>;
        } else {
            return null;
        }
    };
    const currencyValueFormatter = (value) => {       
        if (value === undefined || value === null){
            return null;
        }
        const num = Number(value);
        if (!isNaN(num)) {
            const isNegative = num < 0;

            const formattedValue = isNegative
                ? `($${Math.abs(num).toLocaleString('en-US', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                })})`
                : `$${num.toLocaleString('en-US', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                })}`;
            const style = isNegative ? { color: 'red' } : null;

            return <span style={style}>{formattedValue}</span>;
        } else {
            return null;
        }
    };
    const gridValueFormatter = (params) => {
        return <input type='checkbox' checked={params.value} />;
    };
    const GetSelectedCustomView = async (CustomViewId) => {
      
        try {
            const response = await sbaAxios({
                url: `${getSelectedCustomView}/${CustomViewId}`,
                method: 'get',
            });    
            if (response) {
                const formattedDef = response.map((item) => {
                    console.log(item)
                    const sortOrder = gridsortorder?.find((order) => order.SortBy === item.CustomViewPageColumnName)?.SortOrder;
                    return {
                        ...item,
                        useValueFormatterForExport: true,
                    
                        field: item.CustomViewPageColumnName === "Contact/CompanyName" ? "ContactCompanyName" :
                               //item.CustomViewPageColumnName === "InvestmentStatus" ? "InvestmentStatusName" :
                               item.CustomViewPageColumnName === "Stage" ? "PipelineStageName" :
                               item.CustomViewPageColumnName === "OpportunityType" ? "PipelineTypeName" :
                               item.CustomViewPageColumnName === "AdditionalOpportunity" ? "IsAdditionalOpportunity" :
                               item.CustomViewPageColumnName === "Insurance" ? "IsInsurance" :
                               item.CustomViewPageColumnName === "Size" ? "PipelineSizeName" :
                               item.CustomViewPageColumnName === "Status" ? "PipelineStatusName" :
                               item.CustomViewPageColumnName === "OpportunityStatus" ? "PipelineProbabilityName" :
                               item.CustomViewPageColumnName === "TransactionType" ? "PipelineTransactionTypeName" :
                               item.CustomViewPageColumnName === "MinValue" ? "MinAmount" :
                               item.CustomViewPageColumnName === "MaxValue" ? "MaxAmount" :
                               item.CustomViewPageColumnName === "Date" ? "PipelineDate" :
                               item.CustomViewPageColumnName === "LeadSource" ? "ContactSource" :
                               item.CustomViewPageColumnName === "Comments" ? "Comments" :
                               item.CustomViewPageColumnName === "ModifiedBy" ? "ModifiedByName" :
                               item.CustomViewPageColumnName === "ModifiedDate" ? "ModifiedDate" :
                               item.CustomViewPageColumnName === "Owner" ? "OwnerFullName" :
                               item.CustomViewPageColumnName === "LastCommunicationDate" ? "CommunicationDate" :
                               item.CustomViewPageColumnName === "EstimatedCloseDate" ? "EstimatedCloseDate" :
                               null,
                    
                        valueFormatter: (
                            item.CustomViewPageColumnName === "LastCommunicationDate" ||
                            item.CustomViewPageColumnName === "Date" ||
                            item.CustomViewPageColumnName === "ModifiedDate"
                        )
                            ? (data) => data.value ? moment(data.value).format('MM-DD-YYYY') : ""
                            : (
                                item.CustomViewPageColumnName === "MinValue" ||
                                item.CustomViewPageColumnName === "MaxValue"
                            )
                            ? (data) => FormatCurrencyGrid(data.value)
                            : null,
                    
                        headerName: item.CustomViewPageColumnName === "Contact/CompanyName" ? "Contact" :
                                    //item.CustomViewPageColumnName === "InvestmentStatus" ? "Investment Status" :
                                    item.CustomViewPageColumnName === "Stage" ? "Stage" :
                                    item.CustomViewPageColumnName === "OpportunityType" ? "Opportunity Type" :
                                    item.CustomViewPageColumnName === "AdditionalOpportunity" ? "Additional Opportunity" :
                                    item.CustomViewPageColumnName === "Insurance" ? "Insurance" :
                                    item.CustomViewPageColumnName === "Size" ? "Size" :
                                    item.CustomViewPageColumnName === "OpportunityStatus" ? "Opportunity Status" :
                                    item.CustomViewPageColumnName === "MinValue" ? "Min Value" :
                                    item.CustomViewPageColumnName === "MaxValue" ? "Max Value" :
                                    item.CustomViewPageColumnName === "Date" ? "Date" :
                                    item.CustomViewPageColumnName === "TransactionType" ? "TransactionType" :
                                    item.CustomViewPageColumnName === "Owner" ? "Owner" :
                                    item.CustomViewPageColumnName === "EstimatedCloseDate" ? "Estimated Close Date" :
                                    item.CustomViewPageColumnName === "LeadSource" ? "Lead Source" :
                                    item.CustomViewPageColumnName === "Status" ? "Status" :
                                    null,
                    
                        sort: sortOrder ? sortOrder : null,
                        sortable: true,
                    
                        cellClass: (
                            item.CustomViewPageColumnName === "MinValue" ||
                            item.CustomViewPageColumnName === "MaxValue"
                        ) ? 'CurrencyCell' : null,
                    
                        cellRenderer: (
                            item.CustomViewPageColumnName === "MinValue" ||
                            item.CustomViewPageColumnName === "MaxValue"
                        )
                            ? (data) => currencyValueFormatter(data.value)
                            : (
                                item.CustomViewPageColumnName === "AdditionalOpportunity" ||
                                item.CustomViewPageColumnName === "Insurance"
                            )
                            ? gridValueFormatter
                            : null,
                    };
                }).filter(item=>item.CustomViewPageColumnName != "TransactionType");
                const isECDColumn = response.find((item) => item.CustomViewPageColumnName === "EstimatedCloseDate") || null;
                if(!isECDColumn){
                    formattedDef.push({field: "EstimatedCloseDate", headerName:"Estimated Close Date"})
                }
                formattedDef.push({ field: "Action", headerName: "Action", cellRenderer: ActionButtonRenderer, filter: false });
                
                // formattedDef.sort(item=>item.CustomViewPageColumnName === "Contact/CompanyName")
                const filteredFormattedDef = formattedDef.filter(item => item.CustomViewPageColumnName !== "InvestmentStatus");
                setselectedcolumn(filteredFormattedDef);
              //setselectablecolumn(response);
            }         
        }
        catch (e) {
            console.log(e, 'Error Fetching the  view data')

        };
    };  
    const enterclick = () => {
        const probabilityIds = ProbabilityId.map(item => item.PipelineProbabilityId);
        const stageIds = stageId.map(item => item.PipelineStageId);
        const typeIds = TypeId.map(item => item.PipelineTypeId);
        const insuranceIds = InsuranceId.map(item => item.InsuranceId);
        const sizeIds = SizeId.map(item => item.PipelineSizeId);
        const sourceIds = SourceId.map(item => item.ContactSource);
        const ownerIds = OwnerId.map(item => item.UserId);  
        GetEnterPipeline({
            statusIdList: selectstatusId !== 0 ? selectstatusId : "1,4,5",
            probabilityIdList: probabilityIds.length !== 0 ? probabilityIds.join(",") : null,
            stageIdList: stageIds.length !== 0 ? stageIds.join(",") : null,
            typeIdList: typeIds.length !== 0 ? typeIds.join(",") : null,
            isInsuranceList: insuranceIds.length !== 0 ? insuranceIds.join(",") : null,
            sizeIdList: sizeIds.length !== 0 ? sizeIds.join(",") : null,
            contactSourceList: sourceIds.length !== 0 ? sourceIds.join(",") : null,
            sbaOwnerList: ownerIds.length !== 0 ? ownerIds.join(",") : null
        });


    }
    const cancelclick = () => {
        setProbabilityId([]);
        setstageId([]);
        setTypeId([]);
        setInsuranceId([]);
        setSizeId([]);
        setSourceId([]);
        setOwnerId([]);
        GetEnterPipeline({
            statusIdList: selectstatusId !== 0 ? selectstatusId : "1,4,5",
            probabilityIdList: null,
            stageIdList: null,
            typeIdList: null,
            isInsuranceList: null,
            sizeIdList: null,
            contactSourceList: null,
            sbaOwnerList:null
        });

    }
    const Level = [{ BreadCrumb: "CRM >", Routes: `${UrlPath.Investor}` }, { BreadCrumb: `Opportunities`, Routes: `${UrlPath.Opportunities}` }] 

    //add and remove column
    const Addclk = () => {
      
         const newcolumn = availablecolumnRef.current.api.getSelectedRows();
        const exists = selectablecolumn.some(item => item.CustomViewPageColumnName === newcolumn[0].CustomViewPageColumnName);
        if (!exists) {
            setselectablecolumn([...selectablecolumn, newcolumn[0]]);
        }

    }
    const Removeclk = () => {
        
        const deletecolumn = selectedViewcolumnApi.current.api.getSelectedRows();
        const updatedSelectableColumn = selectablecolumn.filter(item => {
            return !deletecolumn.some(deleteItem => deleteItem.CustomViewPageColumnName === item.CustomViewPageColumnName);
        });
        setselectablecolumn(updatedSelectableColumn);
    };
    // change events
    const CustomViewchange = (e) => {  
        setSelectedCustomViewData(e.value);
        GetSelectedCustomView(e.value.CustomViewID);   
        Selectedcolumndata(e.value.CustomViewID);
        GetStatusSettingSort(e.value.CustomViewID);
        setSelectedView(e.value)
        GetStatusSetting(e.value.CustomViewID);
        GetsettingNames(e.value.CustomViewID);
        setProbabilityId([]);
        setstageId([]);
        setTypeId([]);
        setInsuranceId([]);
        setSizeId([]);    
        setContactNotes();     
    };
    
    const Viewchange = (e) => {
        const value = e.value;     
        Selectedcolumndata(e.value.CustomViewID);
        setSelectedView(e.value)
        GetStatusSettingSort(e.value.CustomViewID);
        GetsettingNames(e.value.CustomViewID);
        setselectsortvalue([]);
        setselectsortorder([]);   
    };
    const sortvaluechange = (event) => {
        setselectsortvalue(event.value);
    }
    const sortOrderchange = (event) => {
        setselectsortorder(event.value);
    }
    const GetsettingNames = async (viewId) => {
        viewId=viewId===undefined?1:viewId
        const response = await sbaAxios({
            url: `${getCustomViewSettings}/${viewId},${false}`,
            method: 'get',
        });
       
        var settingNames = response.map(item => item.SettingName);
        settooltipData(settingNames);
        const updatedStatus = {
            Active: false,
            Inactive: false,
            NoOpportunity: false,
            Won: false,
            Lost: false
        };

        settingNames.map(item => {
            if (item === "Active") {
                updatedStatus["Active"] = true;
            } else if (item === "Inactive") {
                updatedStatus["Inactive"] = true;
            } else if (item === "No Opportunity") {
                updatedStatus["NoOpportunity"] = true;
            } else if (item === "Won") {
                updatedStatus["Won"] = true;
            } else if (item === "Lost") {
                updatedStatus["Lost"] = true;
            }
            return item;
        });

        setIncludeStatus(updatedStatus);

    }
 const GetStatusSetting = async (viewId) => {
       
        const response =  await sbaAxios({
            url: `${getCustomViewSettings}/${viewId},${false}`,
            method: 'get',
        }); 
        var selectedStatus =   response.map(item => (
            item.SettingValue)).join(",");
        LoadSummaryText(selectedStatus.length===0?"1,4,5":selectedStatus);
        setselectstatusId(selectedStatus);
        setpipelinedata({ ...pipelinedata, "StatusIdList": selectedStatus.length===0 || selectedStatus===""?"1,4,5":selectedStatus });
            GetPipeline({
                "statusIdList": selectedStatus.length===0 || selectedStatus===""?"1,4,5":selectedStatus,
                "probabilityIdList": null,
                "stageIdList": null,
                "typeIdList": null,
                "isInsuranceList": null,
                "sizeIdList": null,
                "contactSourceList": null,
                "sbaOwnerList": null
            });
         
    }
 const GetStatusSettingSort = async (viewId) => {  
        const response = await sbaAxios({
            url: `${getCustomViewSettings}/${viewId},${true}`,
            method: 'get',
        });

        const customSortingSettings = response.filter(value => value.SettingName === "CustomSorting");
        if (customSortingSettings) {
            setgridsortorder(customSortingSettings[0]?.CustomSorting)
        }
        else {
            setgridsortorder([]);
        }
    }
 const Probabilitychng = (e) => {
        let value = e.value || [];

        const validNames = Probability.map(p => p.PipelineProbilityName?.trim());

        // Filter out any values that are not in the Probability list
        value = value.filter(v =>
            Probability.some(p =>
                p.PipelineProbilityName.trim() === v?.PipelineProbilityName?.trim()
            )
        );

        const currentSelectAll = ProbabilityId?.some((i) => i?.PipelineProbilityName?.trim() === "All") || false;
        const nextSelectAll = value.some((i) => i?.PipelineProbilityName?.trim() === "All");
        const currentCount = probabilityselected.value.length;
        const nextCount = value?.length;

        if (
            nextCount > currentCount &&
            !currentSelectAll &&
            !nextSelectAll &&
            Probability.length - 1 === nextCount
        ) {
            value = Probability;
        } else if (
            nextCount < currentCount &&
            currentCount === Probability.length &&
            currentSelectAll &&
            nextSelectAll
        ) {
            value = value.filter((v) => v.PipelineProbilityName.trim() !== "All");
        } else if (!currentSelectAll && nextSelectAll) {
            value = Probability;
        } else if (currentSelectAll && !nextSelectAll) {
            value = [];
        }

        setProbabilityselected({ value });
        setProbabilityId(value);
    };
 const Typechng = (e) => {
        const currentSelectAll = TypeId?.some((i) => i?.PipelineTypeName?.trim() === "All") || false;
        const nextSelectAll = e.value.some((i) => i?.PipelineTypeName?.trim() === "All");
        let value = e.value;
        const currentCount = typeselected.value.length;
        const nextCount = value?.length;
        if (
            nextCount > currentCount &&
            !currentSelectAll &&
            !nextSelectAll &&
            Type.length - 1 === nextCount
        ) {
            value = Type;
        } else if (
            nextCount < currentCount &&
            currentCount === Type.length &&
            currentSelectAll &&
            nextSelectAll
        ) {
            value = value.filter((v) => v.PipelineTypeName.trim() !== "All");
        } else if (!currentSelectAll && nextSelectAll) {
            value = Type
        } else if (currentSelectAll && !nextSelectAll) {
            value = [];
        }
        
        setTypeId(value);    

    };
 const Insurancechng = (e) => {
        const currentSelectAll = InsuranceId?.some((i) => i?.InsuranceName?.trim() === "All") || false;
        const nextSelectAll = e.value.some((i) => i?.InsuranceName?.trim() === "All");
        let value = e.value;
        const currentCount = insuranceselected.value.length;
        const nextCount = value?.length;
        if (
            nextCount > currentCount &&
            !currentSelectAll &&
            !nextSelectAll &&
            Insurance.length - 1 === nextCount
        ) {
            value = Insurance;
        } else if (
            nextCount < currentCount &&
            currentCount === Insurance.length &&
            currentSelectAll &&
            nextSelectAll
        ) {
            value = value.filter((v) => v.InsuranceName.trim() !== "All");
        } else if (!currentSelectAll && nextSelectAll) {
            value = Insurance
        } else if (currentSelectAll && !nextSelectAll) {
            value = [];
        }
        setInsuranceselected({value})
        setInsuranceId(value);
    };
 const stagechange = (e) => {
        const currentSelectAll = stageId?.some((i) => i?.PipelineStageName?.trim() === "All") || false;
        const nextSelectAll = e.value.some((i) => i?.PipelineStageName?.trim() === "All");
        let value = e.value;
        const currentCount = stageselected.value.length;
        const nextCount = value?.length;

        if (
            nextCount > currentCount &&
            !currentSelectAll &&
            !nextSelectAll &&
           stage.length - 1 === nextCount
        ) {
            value = stage;
        } else if (
            nextCount < currentCount &&
            currentCount === stage.length &&
            currentSelectAll &&
            nextSelectAll
        ) {
            value = value.filter((v) => v.PipelineStageName.trim() !== "All");
        } else if (!currentSelectAll && nextSelectAll) {
            value = stage
        } else if (currentSelectAll && !nextSelectAll) {
            value = [];
        }
          setStageselected({value})
        setstageId(value);
    };
 const Sizechange = (e) => {
        const currentSelectAll = SizeId?.some((i) => i?.PipelineSizeName?.trim() === "All") || false;
        const nextSelectAll = e.value.some((i) => i?.PipelineSizeName?.trim() === "All");
        let value = e.value;
        const currentCount = sizeselected.value.length;
        const nextCount = value?.length;
        if (
            nextCount > currentCount &&
            !currentSelectAll &&
            !nextSelectAll &&
            Size.length - 1 === nextCount
        ) {
            value = Size;
        } else if (
            nextCount < currentCount &&
            currentCount === Size.length &&
            currentSelectAll &&
            nextSelectAll
        ) {
            value = value.filter((v) => v.PipelineSizeName.trim() !== "All");
        } else if (!currentSelectAll && nextSelectAll) {
            value = Size
        } else if (currentSelectAll && !nextSelectAll) {
            value = [];
        }
        setSizeselected({value})
        setSizeId(value);
    };
 const Sourcechange = (e) => {
        const currentSelectAll = SourceId?.some((i) => i?.ContactSource?.trim() === "All") || false;
        const nextSelectAll = e.value.some((i) => i?.ContactSource?.trim() === "All");
        let value = e.value;
        const currentCount = sourceselected.value.length;
        const nextCount = value?.length;
        if (
            nextCount > currentCount &&
            !currentSelectAll &&
            !nextSelectAll &&
            Source.length - 1 === nextCount
        ) {
            value = Source;
        } else if (
            nextCount < currentCount &&
            currentCount === Source.length &&
            currentSelectAll &&
            nextSelectAll
        ) {
            value = value.filter((v) => v.ContactSource.trim() !== "All");
        } else if (!currentSelectAll && nextSelectAll) {
            value = Source
        } else if (currentSelectAll && !nextSelectAll) {
            value = [];
        }
        setSourceselected({value})
        setSourceId(value);
    };
 const Ownerchange = (e) => {
        const currentSelectAll = OwnerId?.some((i) => i?.FullName?.trim() === "All") || false;
        const nextSelectAll = e.value.some((i) => i?.FullName?.trim() === "All");
        let value = e.value;
        const currentCount = ownerselected.value.length;
        const nextCount = value?.length;
        if (
            nextCount > currentCount &&
            !currentSelectAll &&
            !nextSelectAll &&
            Owner.length - 1 === nextCount
        ) {
            value = Owner;
        } else if (
            nextCount < currentCount &&
            currentCount === Owner.length &&
            currentSelectAll &&
            nextSelectAll
        ) {
            value = value.filter((v) => v.FullName.trim() !== "All");
        } else if (!currentSelectAll && nextSelectAll) {
            value = Owner
        } else if (currentSelectAll && !nextSelectAll) {
            value = [];
        }
        setOwnerselected({value})
       
        setOwnerId(value)
    };
 const SortAddclk = () => {
        if (selectsortvalue && selectsortorder) {
            if (gridsortorder) {         
                if (!Array.isArray(gridsortorder)) {
                    console.error('gridsortorder is expected to be an array but it is:', typeof gridsortorder);
                    return;
                }
                const exists = gridsortorder.some(item => item.SortBy === selectsortvalue.CustomViewPageColumnName);
                if (!exists) {
                    setgridsortorder([...gridsortorder, { "SortBy": selectsortvalue.CustomViewPageColumnName, "SortOrder": selectsortorder.SortName }]);
                }
            } else {         
                setgridsortorder([{ "SortBy": selectsortvalue.CustomViewPageColumnName, "SortOrder": selectsortorder.SortName }]);
            }
        }
    }
 const SortEditclk = () => {
        const deletecolumn = sortcolumnApi.current.api.getSelectedRows();
        const updatedSelectableColumn = gridsortorder?.filter(item => {
            return !deletecolumn.some(deleteItem => deleteItem.SortBy === item.SortBy);
        });
        setgridsortorder(updatedSelectableColumn);  
    }
 const OpenCustomWindow = () => {     
     setshowView(true);
    
    };
 const defaultColDef = {
        sortable: true,
        filter: true,
        floatingFilter: true,
        flex: 1,
        filter: "agTextColumnFilter",
        minWidth:100,
        wrapText: true,
        autoHeaderHeight: true,
        resizable:true
    };
 const fetchGridData = async () => {
        try {
            const customSettings = await getCustomSetting();
            const column = customSettings.columns;
            const selectedColumn = column.filter((item) => item !== "Action").filter(item=>item.CustomViewPageColumnName != "TransactionType");
            setselectedcolumn(selectedColumn);
          setAppliedFilter(customSettings.filters);
        } catch (error) {
          console.error("Error fetching custom settings:", error);
        }
      };
 const getCustomSetting = async () => {
        try {
            const response = await sbaAxios({ url: `${getCustomSettings}${1020}` });
            if (response) {
                const apiColDef = JSON.parse(response.CustomSettingsValue);
                const apiFilters = JSON.parse(response.CustomFilterValue);            
                const formattedDef = apiColDef.map((item) => {
                    const sortOrder = gridsortorder?.find((order) => order.SortBy === item.colId)?.SortOrder;

                    return {
                        ...item,
                        field: item.colId,
                        useValueFormatterForExport: true,
                    
                        valueFormatter:
                            item.colId === "PipelineDate" ||
                            item.colId === "CommunicationDate" ||
                            item.colId === "ModifiedDate"
                                ? (data) => data.value ? moment(data.value).format('MM-DD-YYYY') : ""
                                : item.colId === "MinValue" || item.colId === "MaxValue"
                                    ? (data) => FormatCurrencyGrid(data.value)
                                    : null,
                    
                        headerName:
                            item.colId === "ContactCompanyName" ? "Contact" :
                            item.colId === "InvestmentStatusName" ? "Investment Status" :
                            item.colId === "PipelineStageName" ? "Stage" :
                            item.colId === "PipelineTypeName" ? "Type" :
                            item.colId === "IsAdditional" ? "Additional Opportunity" :
                            item.colId === "IsInsurance" ? "Insurance" :
                            item.colId === "PipelineSizeName" ? "Size" :
                            item.colId === "PipelineProbabilityName" ? "Probability" :
                            item.colId === "MinValue" ? "Min Value" :
                            item.colId === "MaxValue" ? "Max Value" :
                            item.colId === "OwnerFullName" ? "Owner" :
                            item.colId === "Status" ? "Status" :
                            item.colId,
                    
                        sort: sortOrder ? sortOrder : null,
                    
                        cellRenderer:
                            item.colId === "MinValue" || item.colId === "MaxValue"
                                ? (data) => currencyValueFormatter(data.value)
                                : item.colId === "IsAdditional" || item.colId === "IsInsurance"
                                    ? gridValueFormatter
                                    : null
                    };
                    
                });

                formattedDef.push({ field: "Action", headerName: "Action", cellRenderer: ActionButtonRenderer, filter: false });
                return { columns: formattedDef, filters: apiFilters };
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    };
 const excelStyles = useMemo(() => {
        return [
            {
                id: 'CurrencyCell',
                numberFormat: {
                    format: '$ #,##0;$ [red]{#,##0}',
                },
            },
        ];
      }, []);
 const Savesetting = (Mode) => {     
        let ifsave = true;
        const columnIds = selectablecolumn.map(item => item.CustomViewPageColumnId);
        const sortingdata = [];
        const additionalParamsValue = [];
        if (gridsortorder) {
            sortingdata.push(
                ...gridsortorder?.map((item) => ({

                    "id": 0,
                    "sortBy": item.SortBy,
                    "sortOrder": item.SortOrder,
                    "order": 0

                }))
            );
        }
        
        const trueItemsList = Object.entries(IncludeStatus)
            .filter(([key, value]) => value === true)
            .map(([key, value]) => key);
        if (trueItemsList) {
            trueItemsList?.map(item => {
                if (item === "Won") {
                    additionalParamsValue.push(2);
                } else if (item === "Active") {
                    additionalParamsValue.push(1);
                } else if (item === "Inactive") {
                    additionalParamsValue.push(4)
                } else if (item === "NoOpportunity") {
                    additionalParamsValue.push(5)
                } else if (item === "Lost") {
                    additionalParamsValue.push(3)
                }
                return item;
            });   
        }
        const savedata = {
            "additionalParamsName": trueItemsList.join(),
                "additionalParamsValue": additionalParamsValue.join(),
                "customViewId": (Mode ==='New')?0: selectedView.CustomViewID,
                "customViewName": (Mode === 'New') ? updateViewName:selectedView.CustomViewName,
                "customViewColumnIds": columnIds.join(),
                "customSorting": sortingdata ? sortingdata:null,
                "pageId": 433,
                "userId": 0
         }        
        if (selectablecolumn.length===0) {
            ifsave = false;
            SBNotify({ Msg: " Please Select Atleast One Column ", type: "error" });
        }
        if (trueItemsList.length === 0) {
            ifsave = false;
            SBNotify({ Msg: " Please Select Atleast One Status ", type: "error" });
        }
        if (ifsave) {
            sbaAxios({
                url: `${insertPipelineCustomviewSettings}`,
                method: "post",
                data: savedata,
            }).then((response) => {

                if (response === -1) {
                    SBNotify({ Msg: "View Name already Exists", type: "error" });
                } else {
                   
                    GetAllCustomViews(response);
                    GetSelectedCustomView(response);
                    GetStatusSetting(response);
                    Selectedcolumndata(response);
                    GetStatusSettingSort(response);
                    GetsettingNames(response);
                    setselectsortvalue([]);
                    setselectsortorder([]);
                     LoadSummaryText(additionalParamsValue.join(','));
                    setshowView(false);
                    setRenamemodal(false);
                    if (Mode === 'New') {
                        setSelectedCustomViewData({ CustomViewName: updateViewName, CustomViewID: response });
                        setSelectedView({ CustomViewName: updateViewName, CustomViewID: response });
                       
                    }
                    else {
                       
                        setSelectedCustomViewData({ CustomViewName: selectedView.CustomViewName, CustomViewID: selectedView.CustomViewID });
                        setSelectedView({ CustomViewName: selectedView.CustomViewName, CustomViewID: selectedView.CustomViewID });
                    }
                    setProbabilityId([]);
                    setstageId([]);
                    setTypeId([]);
                    setSizeId([]);
                    setSourceId([]);
                    setInsuranceId([]);
                    setOwnerId([]);
                }
            }).catch((error) => {
                SBNotify({ Msg: "some error  occured", type: "error" });
            });
        }

    };
 const DeleteCustomViews = async () => {
        let del =true

        if (selectedView.CustomViewName === "Default") {
            del = false
            SBNotify({ Msg: "Should not be able to delete Default View ", type: "error" });
        }
        if (del) {

            try {
                const response = await sbaAxios({
                    url: `${deleteCustomView}/${selectedView.CustomViewID}`,
                    method: 'get',
                });
                if (response) {
                    setShowdeleteviewModal(false)
                    setSelectedCustomViewData([]);
                    setSelectedView([]);
                    GetAllCustomViews(0);
                    enterclick();
                }
            }
            catch (e) {
                console.log(e, 'Error Fetching the  view data')

            };
        }
    };
 const UpdateCustomViewName = async () => {  
        try {
            const response = await sbaAxios({
                url: `${updateCustomViewName}/${updateViewName},${selectedView.CustomViewID}`,
                method: 'get',
            });
            if (response) {
                setRenamemodal(false);
               // enterclick();
                GetAllCustomViews(selectedView.CustomViewID);
                Selectedcolumndata(selectedView.CustomViewID);
                setSelectedCustomViewData({ CustomViewName: updateViewName, CustomViewID: selectedView.CustomViewID });
                setSelectedView({ CustomViewName: updateViewName, CustomViewID: selectedView.CustomViewID });
     
            }
        }
        catch (e) {
            console.log(e, 'Error Fetching the  view data')

        };
    };
 const RenameEditbutton = () => {
        setRenamemodal(true)
        setTitleName("Rename View");
        setUpdateViewName(selectedView.CustomViewName);  
    };
 const InsertNewview = () => {
        setRenamemodal(true)
        setTitleName("New View");           
        setUpdateViewName([]);
    };
 const txtChangeNewName = (e) => {
      
        setUpdateViewName(e.target.value);
    };
 const LoadSummaryText =  async (statusIds)=> {
        if (statusIds == undefined)
            statusIds = "1,4,5";
     setSummarydata();
        const response = await sbaAxios({
            url: `${getPipelineSummarydata}/${statusIds}`,
            method: 'get',
        });
        if (response) {
            setSummarydata(response.PipelineCount);
            setPipelineValue(response.PipelineTotalValue);
        }
    }
    const handleColumnMoved = (e) => {
        if (GridRef.current?.columnApi && e?.source === 'toolPanelUi') {
            const updatedColState = GridRef.current.columnApi.getColumnState();
            sessionStorage.setItem('cachedGridColState', JSON.stringify(updatedColState));
        }
    };
 const handleLinkClick = (row) => {
        const ContactId = row.data.ContactId;
        getContactNotes(ContactId);
    }
 const getContactNotes =  async (ContactId)=> {
        const response = await sbaAxios({
        url: `${getInvestorActivities}?contactId=${ContactId}`,
        method: 'get',
    })
    
    const cNotes=response.filter(value => value.EntityTypeId === 0);
    setContactNotes(cNotes);
    setTimeout(() => {
        const storedColState = sessionStorage.getItem('cachedGridColState');
        if (!GridRef.current) {
            return;
        }
        if (!GridRef.current.columnApi) {
            return;
        }
        if (storedColState) {
            const parsed = JSON.parse(storedColState);
            const success = GridRef.current.columnApi.applyColumnState({
                state: parsed,
                applyOrder: true,
            });
            
            sessionStorage.removeItem('cachedGridColState');
        }
    }, 50);
    
    }

    
 const setcustomviewvalue=(val)=>
{
    setSelectedCustomViewData(val)
};
const updateColumnSortOrder=()=>{
    const rows = [];
    selectedViewcolumnApi?.current?.api?.forEachNodeAfterFilterAndSort((node) => rows.push(node.data));
    setselectablecolumn(rows);
}
    return (
        <>

            <TopBar label={"Opportunities"} />
            <div id="opportunitiesList" className="mainContentData">
                <BreadCrumbs Levels={Level} />
                <div className="container-fluid">
                    <div className="bg-white m-4 mb-3 p-3 border rounded">
                        <form action="#">
                            <div className="row pb-3">
                                <div className="col-md-3">
                                    <label for="select fund" className="mb-1 ms-2 fw-semibold fs-12">Custom View</label>
                                    <i className="fa-solid fa-gear  p-2" onClick={() => OpenCustomWindow()} ></i>

                                    <div>
                                        <SBADropDown
                                            className="w-75"
                                            data={CustomViedata}
                                            value={selectedCustomViewData}
                                            textField={"CustomViewName"}
                                            valueField={"CustomViewID"}
                                            onChange={CustomViewchange}
                                        />
                                        <button type="button" className="enter-btn" style={{ marginLeft: '10px' }}  onClick={() => {
                                            setCreateAddEditDrawer(true); setmode("Add"); SetOpportunitiesData(PlainopportunitiesData)
                                        }}>Add</button>
                                    </div>

                                </div>

                            </div>
                        </form>

                    </div>
                    <div className="bg-white m-4 mb-3 p-3 border rounded">
                        <form action="#">
                            <div className="row border-bottom pb-3">
                                <div className="col-md-3">
                                    <label for="select fund" className="mb-1 ms-2 fw-semibold fs-12">Opportunity Status</label>
                                   
                                        <div>
                                            <SBAMultiSelectCheck
                                                className="w-75"
                                                dataItemKey="PipelineProbabilityId"
                                                textField="PipelineProbilityName"
                                                data={Probability}
                                                onChange={Probabilitychng}
                                                onBlur={() => {
                                                    if (!ProbabilityId || ProbabilityId.length === 0) {
                                                        setProbabilityselected({ value: [] });
                                                    }
                                                }}
                                                value={ProbabilityId}
                                                tags={
                                                    ProbabilityId?.length > 0
                                                        ? [
                                                            {
                                                                text: `${ProbabilityId.length} items selected`,
                                                                data: [...ProbabilityId],
                                                            },
                                                        ]
                                                        : []
                                                }
                                                filterable={true}
                                                placeholder="Please Select"
                                            />                                      
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <label for="select fund" className="mb-1 ms-2 fw-semibold fs-12">Stage</label>

                                    <div>
                                        <SBAMultiSelectCheck
                                            className="w-75"
                                            dataItemKey="PipelineStageId"
                                            textField="PipelineStageName"
                                            data={stage}
                                            onChange={stagechange}
                                             value={stageId}
                                            tags={
                                                stageId?.length > 0
                                                    ? [
                                                        {
                                                            text: `${stageId.length} items selected`,
                                                            data: [...stageId],
                                                        },
                                                    ]
                                                    : []
                                            }
                                            filterable={true}
                                            placeholder="Please Select"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <label for="select fund" className="mb-1 ms-2 fw-semibold fs-12">Opportunity Type</label>

                                    <div>
                                        <SBAMultiSelectCheck
                                            className="w-75"
                                            dataItemKey="PipelineTypeId"
                                            textField="PipelineTypeName"
                                            data={Type}
                                            onChange={Typechng}
                                           value={TypeId}
                                            tags={
                                                TypeId?.length > 0
                                                    ? [
                                                        {
                                                            text: `${TypeId.length} items selected`,
                                                            data: [...TypeId],
                                                        },
                                                    ]
                                                    : []
                                            }
                                            filterable={true}
                                            placeholder="Please Select"
                                        />
                                    </div>
                                </div>
                                
                                <div className="col-md-3">
                                    <label for="select fund" className="mb-1 ms-2 fw-semibold fs-12">Size</label>

                                    <div>
                                        <SBAMultiSelectCheck
                                            className="w-75"
                                            dataItemKey="PipelineSizeId"
                                            textField="PipelineSizeName"
                                            data={Size}
                                            onChange={Sizechange}
                                            value={SizeId}
                                            tags={
                                                SizeId?.length > 0
                                                    ? [
                                                        {
                                                            text: `${SizeId.length} items selected`,
                                                            data: [...SizeId],
                                                        },
                                                    ]
                                                    : []
                                            }
                                            filterable={true}
                                            placeholder="Please Select"
                                        />
                                        
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <label for="select fund" className="mb-1 ms-2 fw-semibold fs-12">Lead Source</label>

                                    <div>
                                        <SBAMultiSelectCheck
                                            className="w-75"
                                            dataItemKey="ContactSource"
                                            textField="ContactSource"
                                            data={Source}
                                           onChange={Sourcechange}
                                          value={SourceId}
                                            tags={
                                                SourceId?.length > 0
                                                    ? [
                                                        {
                                                            text: `${SourceId.length} items selected`,
                                                            data: [...SourceId],
                                                        },
                                                    ]
                                                    : []
                                            }
                                            filterable={true}
                                            placeholder="Please Select"
                                        />
                                       
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <label for="select fund" className="mb-1 ms-2 fw-semibold fs-12">Owner</label>

                                    <div>
                                        <SBAMultiSelectCheck
                                           
                                            className="w-75"
                                            dataItemKey="UserId"
                                            textField="FullName"
                                            data={Owner}
                                            onChange={Ownerchange}
                                            value={OwnerId}
                                            tags={
                                                OwnerId?.length > 0
                                                    ? [
                                                        {
                                                            text: `${OwnerId.length} items selected`,
                                                            data: [...OwnerId],
                                                        },
                                                    ]
                                                    : []
                                            }
                                            filterable={true}
                                            placeholder="Please Select"
                                        />
                                    </div>
                                </div>
                                <div className="mt-3 d-flex">
                                    <button type="button" className="enter-btn" onClick={enterclick}>Enter</button>
                                    <button type="button" className="cancel-btn ms-2" onClick={cancelclick}>Clear All</button>
                                   

                                   <span id="TotalToolTip" className="ms-auto" style={{ color: "337ab7" }}>Total :{summaryData} | {"$"+currencyFormatter(pipelineValue)} </span>
                                </div>
                            </div>
                        </form>
                        <div className="mx-4 p-3">
                            <div className="row">
                                <Splitter orientation={'vertical'}>
                                    <Splitter panes={panes} onChange={onChange}>
                                    <div class=" bg-white  rounded">
                                            <div className="mt-3 d-flex justify-content-end " style={{ marginTop: "20px" }}>
                                                <div className="d-flex justify-content-end gap-2">
                                                
                                <button
                                    type="button"
                                    className="p-sm-btn mx-1"
                                    onClick={() => {
                                        exportToExcelUsingRef(
                                             GridRef,
                                            "Opportunities.xlsx"
                                        );
                                    }}
                                >
                                    <img src={download} alt="" /> Export
                           </button>
                                
                                    
                                                </div>
                                            </div>
                                            <SBGrid                                
                                    column={column}
                                    ref={GridRef}
                                    row={GridData}
                                    pageSize={15}
                                    componentID={1020}
                                    rowSelection="single"
                                   defaultColDef={defaultColDef}
                                   onRowClicked={handleLinkClick}   
                                   onColumnMoved={(e)=>{handleColumnMoved(e)}}                                                      
                                    gridStyle={{ width: "100%", height: "700px" }}
                                    excelStyles={excelStyles}
                                ></SBGrid>
                                        </div>

                                        <div class="row">
                                             <ContactNotes notes={contactnotes}></ContactNotes>
                                        </div>
                        </Splitter>
                                </Splitter>
                            </div>
                        </div>
                        {/* View Settings Column ----- */}
                        <SBADrawer
                            open={showView}
                            setOpen={setshowView}
                            close={false}
                            title={"Custom View"}
                        >
                            <div className="drawer">
                                <div>
                                    <div className="mb-4">
                                        <label for="select fund" className="mb-1 ms-2 fw-semibold fs-12"> View Name</label>

                                        <div>
                                            <SBADropDown
                                                className="w-50"
                                                data={CustomViedata}
                                                value={selectedView}
                                                textField={"CustomViewName"}
                                                valueField={"CustomViewID"}
                                                onChange={Viewchange}
                                                popupSettings={{ className: "modalDD" }}
                                            />
                                            <i
                                                className="fas fa-pencil" onClick={RenameEditbutton}
                                                style={{ margin: "0 8px", cursor: "pointer" }}
                                            ></i>
                                            <i
                                                className="fas fa-trash" onClick={() => {
                                                    setShowdeleteviewModal(true);
                                                }}
                                                style={{ color: "#DF001B", margin: "0 8px", cursor: "pointer" }}
                                            ></i>
                                           
                                        </div>

                                    </div>

                                    <div className="mb-4">
                                        Include Status:
                              <div className="d-flex flex-column gap-1 ms-4">
                                            {/* <label className="checkbox-label d-block">
                                                <input
                                                    type="checkbox"
                                                    className="checkbox-input"
                                                    name="Won"
                                                    checked={IncludeStatus.Won}
                                                    onChange={() => {                                                      
                                                        setIncludeStatus(prevState => ({
                                                            ...prevState,
                                                            Won: !IncludeStatus.Won
                                                        }))
                                                    }}
                                                />
                                                <span className="mx-2">Won</span>
                                            </label> */}
                                            <label className="checkbox-label d-block">
                                                <input
                                                    type="checkbox"
                                                    className="checkbox-input"
                                                    name="Active"
                                                    checked={IncludeStatus.Active}
                                                    onChange={() => {
                                                        setIncludeStatus(prevState => ({
                                                            ...prevState,
                                                            Active: !IncludeStatus.Active
                                                        }))
                                                    }}
                                                />
                                                <span className="mx-2">Active</span>
                                            </label>
                                            <label className="checkbox-label d-block">
                                                <input
                                                    type="checkbox"
                                                    className="checkbox-input"
                                                    name="Inactive"
                                                    checked={IncludeStatus.Inactive}
                                                    onChange={() => {
                                                        setIncludeStatus(prevState => ({
                                                            ...prevState,
                                                            Inactive: !IncludeStatus.Inactive
                                                        }))
                                                    }}
                                                />
                                                <span className="mx-2">Inactive</span>
                                            </label>
                                            {/* <label className="checkbox-label d-block">
                                                <input
                                                    type="checkbox"
                                                    className="checkbox-input"
                                                    name="NoOpportunity"
                                                    checked={IncludeStatus.NoOpportunity}
                                                    onChange={() => {
                                                        setIncludeStatus(prevState => ({
                                                            ...prevState,
                                                            NoOpportunity: !IncludeStatus.NoOpportunity
                                                        }))
                                                    }}
                                                />
                                                <span className="mx-2">No Opportunity</span>
                                            </label>
                                            <label className="checkbox-label d-block">
                                                <input
                                                    type="checkbox"
                                                    className="checkbox-input"
                                                    name="Lost"
                                                    checked={IncludeStatus.Lost}
                                                    onChange={() => {
                                                        setIncludeStatus(prevState => ({
                                                            ...prevState,
                                                            Lost: !IncludeStatus.Lost
                                                        }))
                                                    }}
                                                />
                                                <span className="mx-2">Lost</span>
                                            </label> */}
                                        </div>
                                    </div>

                                    <div className="container">
                                        <div className="d-flex gap-4 mb-2">
                                            <div className="d-flex flex-column flex-grow-1">
                                                <div className="mb-2">
                                                    <label className="label">
                                                        Sort By
                                                    </label>
                                                    <div>
                                                        <SBADropDown
                                                            className="w-100"
                                                            data={selectablecolumn}
                                                            textField={"CustomViewPageColumnName"}
                                                            valueField={"CustomViewPageColumnId"}
                                                            onChange={sortvaluechange}
                                                            value={selectsortvalue}
                                                            popupSettings={{ className: "modalDD" }}
                                                       ></SBADropDown>
                                                    </div>
                                                </div>
                                                <div className="mb-2">
                                                    <label className="label">Sort Order</label>
                                                    <SBADropDown
                                                        className="w-100"
                                                        data={SortOrderData}
                                                        textField={"SortName"}
                                                        valueField={"SortId"}
                                                        value={selectsortorder}
                                                        onChange={sortOrderchange}
                                                        popupSettings={{ className: "modalDD" }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="d-flex flex-column justify-content-center gap-2">
                                                <button className="p-sm-btn my-1" onClick={SortAddclk}>
                                                    <i className="fa-solid fa-arrow-right" ></i>
                                                </button>
                                                <button className="p-sm-btn my-1" onClick={SortEditclk}>
                                                    <i className="fa-solid fa-arrow-left" ></i>
                                                </button>
                                            </div>
                                            <div className="gridDiv">
                                                <div className="griddata ag-theme-alpine" style={{ height: '20rem', width: 300 }}>
                                                    <AgGridReact
                                                        columnDefs={sortcolumnDefs}
                                                        rowData={gridsortorder}
                                                        defaultColDef={defaultColDef}
                                                        ref={sortcolumnApi}
                                                        rowSelection={'single'}
                                                        rowDragManaged={true}
                                                        animateRows={true}
                                                    >
                                                    </AgGridReact>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                             
                                    <div className='gridcontent d-flex flex-row mt-3' >
                                        <div className='gridDiv' >
                                            <div className=''>Available View Columns</div>
                                            <div className="griddata ag-theme-alpine" style={{ height: '20rem', width: 300 }}>
                                                <AgGridReact
                                                    columnDefs={avalicoldef}
                                                    rowData={availablecolumn}
                                                    rowSelection={'single'}
                                                    ref={availablecolumnRef}
                                                    defaultColDef={defaultColDef}
                                                >
                                                </AgGridReact>
                                            </div>
                                        </div>
                                        <div className='d-flex flex-column justify-content-center px-3'>
                                            <button className='p-sm-btn my-1' onClick={Addclk}>
                                                <i class="fa-solid fa-arrow-right"></i>
                                            </button>
                                            <button className='p-sm-btn my-1' onClick={Removeclk}>
                                                <i class="fa-solid fa-arrow-left"></i>
                                            </button>

                                        </div>
                                        <div className='gridDiv'>
                                            <div className=''>
                                                Selected View Columns
                                                    </div>


                                            <div className='griddata ag-theme-alpine' style={{ height: '20rem', width: 300 }}>
                                                <AgGridReact
                                                    columnDefs={[  {   rowDrag: true,maxWidth:"50",floatingFilter:false },...avalicoldef]}
                                                    rowData={selectablecolumn}
                                                    defaultColDef={defaultColDef}
                                                    ref={selectedViewcolumnApi}
                                                    rowSelection={'single'}
                                                    rowDragManaged={true}
                                                    animateRows={true}
                                                    onRowDragEnd={()=>{updateColumnSortOrder()}}
                                                >
                                                </AgGridReact>
                                            </div>


                                        </div>
                                    </div>

                                    <div className="mt-4">
                                        <button className="s-sm-btn mx-1" onClick={() => {
                                            setshowView(false);
                                        }}>
                                            Cancel
              </button>
                                        <button className="p-sm-btn mx-1" onClick={() => { Savesetting('Edit') }}>
                                            Save
              </button>
                                        <button className="p-sm-btn mx-1" onClick={InsertNewview}
                                        >
                                            Save As
              </button>
                                    </div>
                                </div>
                            </div>
                        </SBADrawer>
                {/* View Settings Column End  ----- */}
                       
                        {/* Rename View Modal ----- */}
                        <div>
                        <Modal className="modal" show={Renamemodal}>
                            <Modal.Header
                                closeButton
                                onClick={() => {
                                    setRenamemodal(false)
                                }}
                            >
                                <Modal.Title>
                                    {titleName}
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Form>
                                    <Form.Group className="mb-4">
                                        <Form.Label>View Name: </Form.Label>
                                        <Form.Control
                                            className="form-control w-75"
                                            type="text"
                                            value={updateViewName}
                                                onChange={txtChangeNewName}
                                                autoFocus
                                            
                                        />
                                    </Form.Group>
                                </Form>
                            </Modal.Body>
                            <Modal.Footer>
                                <button
                                    className="s-sm-btn mx-1"
                                    onClick={() => {
                                        setRenamemodal(false);
                                    }}
                                >
                                    Cancel
                                </button>
                                {titleName === "Rename View" ?
                                    <button
                                            className="p-sm-btn mx-1" onClick={UpdateCustomViewName}
                                        >
                                            Rename 
                                   </button>
                                    :
                                    <button
                                        className="p-sm-btn mx-1"
                                        onClick={() => { Savesetting('New') }}>
                                        Save
                                     </button>
                                }
                            </Modal.Footer>
                            </Modal>

                            {/* View Delete Modal ----- */}
                            <Modal show={showdeleteviewModal}>
                                <Modal.Header
                                    closeButton
                                    onClick={() => {
                                        setShowdeleteviewModal(false);
                                    }}
                                >
                                    <Modal.Title>
                                        Delete View
          </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <p>Do you want delete selected view?</p>
                                </Modal.Body>
                                <Modal.Footer>
                                    <button
                                        className="s-sm-btn mx-1"
                                        onClick={() => {
                                            setShowdeleteviewModal(false);
                                        }}
                                    >
                                        Cancel
          </button>
                                    <button
                                        className="p-sm-btn mx-1"
                                        onClick={DeleteCustomViews}
                                    >
                                        Yes
          </button>
                                </Modal.Footer>
                            </Modal>
                            </div>
                    </div>
                                                       
                </div></div>
                <Tooltip anchorSelect="#TotalToolTip" clickable place="right-end" className="p-2" style={{backgroundColor:'#3C5F7A' , zIndex:2}}>
        <div className="bg-white text-dark p-2" style={{ width: '280px', height: '100%' }}>
        <div>Included Status:</div> 
                    <div>{tooltipData.join(', ')}</div>
        </div>
        </Tooltip>
            {createAddEditDrawer && <CreateAddEditOpportunities open={createAddEditDrawer} setRender={setRender} setOpen={setCreateAddEditDrawer} users={Owner} mode={mode} plainData={pipelinedata} plainDatas={opportunitiesData} selectedCustomViewData={selectedCustomViewData} setSelectedCustomViewData={setcustomviewvalue}/>}
                <DeleteConfirmationModal open={deleteModal} setOpen={setDeleteModal} pipelineId={pipelineId} setRender={setRender}  setSelectedCustomViewData={setcustomviewvalue}/>
                <ToastContainer></ToastContainer>
        </>
    )
}

const pipelinedata = {
    
        "statusIdList": null,
        "probabilityIdList": null,
        "stageIdList": null,
        "typeIdList": null,
        "isInsuranceList": null,
        "sizeIdList": null,
        "contactSourceList": null,
        "sbaOwnerList": null
      
}
const IncludeStatusplain = {
"Won":false,
"Active": false,
 "Inactive": false,
 "NoOpportunity": false,
"Lost":false
}
const dtdate=new Date();
const PlainopportunitiesData= {
    "PipelineId": 0,
    "ContactId": -1,
    "ContactTypeId": 0,
    "ContactCompanyName": "",
    "PipelineStatusId": 0,
    "PipelineStatusName": "",
    "PipelineProbabilityId": 0,
    "PipelineProbabilityName": "",
    "PipelineStageSortOrder": 0,
    "PipelineTransactionTypeId": 1,
    "PipelineTransactionTypeName": "Contribution",
    "ContactSource": "",
    "MinAmount": 0,
    "MaxAmount": 0,
    "PipelineDate": dtdate,
    "Comments": "",
    "CreatedById": 0,
    "CreatedByName": "",
    "CreatedDate": dtdate,
    "ModifiedById": 0,
    "ModifiedByName": "",
    "ModifiedDate": dtdate,
    "OwnerUserId": 0,
    "OwnerFullName": "",
    "CommunicationDate": null,
    "IsWidgetView": false,
    "InvestmentStatusName": "",
    "PipelineStageId": 0,
    "PipelineStageName": "",
    "PipelineTypeId": 0,
    "PipelineTypeName": "",
    "IsAdditionalOpportunity": false,
    "IsInsurance": false,
    "PipelineSizeId": 0,
    "PipelineSizeName": "",
    "EstimatedCloseDate": null
}

const CreateAddEditOpportunities = ({ open, setOpen, mode, plainData, plainDatas, setRender, setSelectedCustomViewData
   }) => {
    const [users,setUsers]=useState([]);
    const [selectedOption, setSelectedRadioOption] = useState("Contact");
    const [GridData, setGridData] = useState([]);
    const [typeData, setTypeData] = useState([]);
    const [statusData, setStatusData] = useState([]);
    const [stageData, setStageData] = useState([]);
    const [probabilityData, setprobabilityData] = useState([]);
    const [transType, setTransType] = useState([]);
    const [ContactCompany, setContactCompany] = useState([]);
    const [ContactCompanydata, setContactCompanydata] = useState([]);
    const [insuranceData, setinsuranceData] = useState([
        { Insurance: "Yes", Value: 0 },
        { Insurance: "No", Value: 1 }
    ]);
    const [additionalOpportunityData, setadditionalOpportunityData] = useState([
        { AdditionalOpportunity: "Yes", Value: 0 },
            { AdditionalOpportunity: "No", Value: 1 }
    ]);
    const [sizeData, setsizeData] = useState([]);
    const userdata = users?.filter(item => item.FullName !== "All");
    const [opportunitiesData,SetOpportunitiesData]=useState([]);
    const transactiontypeval={"PipelineTransactionTypeId":opportunitiesData.PipelineTransactionTypeId,"PipelineTransactionTypeName":opportunitiesData.PipelineTransactionTypeName}
    const contactCompanyval={"ContactId":opportunitiesData.ContactId,"DisplayName":opportunitiesData.ContactCompanyName}
    const sbaOwnerval = { "UserId": opportunitiesData.OwnerUserId, "FullName": opportunitiesData.OwnerFullName}
    const probabilityval={"PipelineProbabilityId":opportunitiesData.PipelineProbabilityId,"PipelineProbilityName":opportunitiesData.PipelineProbabilityName}
    const statusval={"PipelineStatusId":opportunitiesData.pipelineStatusId,"PipelineStatusName":opportunitiesData.PipelineStatusName}
    const stageval={"PipelineStageId":opportunitiesData.PipelineStageId,"PipelineStageName":opportunitiesData.PipelineStageName}
    const typeval={"PipelineTypeId":opportunitiesData.PipelineTypeId,"PipelineTypeName":opportunitiesData.PipelineTypeName}
    const additionalval={"AdditionalOpportunity":opportunitiesData.IsAdditionalOpportunity?"Yes":"No","Value":opportunitiesData.IsAdditionalOpportunity?0:1}
    const insuranceval={"Insurance":opportunitiesData.IsInsurance?"Yes":"No","Value":opportunitiesData.IsInsurance?0:1}
    const sizeval={"PipelineSizeId":opportunitiesData.PipelineSizeId,"PipelineSizeName":opportunitiesData.PipelineSizeName}
    const leadSourceValue = {"leadSourceId":opportunitiesData.ContactSource, "leadSourceName": opportunitiesData.ContactSource}
    

    
    useEffect(()=>{
        GetTransactionType();
        GetPipelineType();
        GetPipelineSize();
        GetPipelineStage();
        GetProbability();
        GetPipelineStatus();
         GetcontactCompany(1);
         getOwners();
    },[])
    useEffect(()=>{
        SetOpportunitiesData (plainDatas)
    },[plainDatas])
    const GetPipelineStatus = async () => {
        try {
            const response = await sbaAxios({
                url: `${getPipelineStatus
                }`,
                method: 'get',
            });
            setStatusData(response);
            
        }
        catch (e) {
            console.log(e, 'Error Fetching the  view data')

        };
    };
    const GetPipelineType = async () => {
        try {
            const response = await sbaAxios({
                url: `${getPipelineType}`,
                method: 'get',
            });


                    setTypeData(response);
        }
        catch (e) {
            console.log(e, 'Error Fetching the  view data')

        };
    };
    const GetPipelineSize = async () => {
        try {
            const response = await sbaAxios({
                url: `${getPipelineSize}`,
                method: 'get',
            });

          
                 setsizeData(response);
           
        }
        catch (e) {
            console.log(e, 'Error Fetching the  view data')

        };
    };
    const GetPipelineStage = async () => {
        try {
            const response = await sbaAxios({
                url: `${getPipelineStage}`,
                method: 'get',
            });
            // const PipelineStage = response.length > 1 ? [{
            //     "PipelineStageId": -1,
            //     "PipelineStageName": "All"
            // }, ...response.sort((a, b) =>
            //     a.PipelineStageName.localeCompare(b.PipelineStageName))] : [...response.sort((a, b) =>
            //     a.PipelineStageName.localeCompare(b.PipelineStageName))];

                setStageData(response);
        }
        catch (e) {
            console.log(e, 'Error Fetching the  view data')

        };
    };
    const GetProbability = async () => {
     
        try {
            const response = await sbaAxios({
                url: `${getProbability}`,
                method: 'get',
            });
           
            setprobabilityData(response);
        }
        catch (e) {
            console.log(e, 'Error Fetching the  view data')

        };
    };
    const GetTransactionType = async () => {
     
        try {
            const response = await sbaAxios({
                url: `${getPiplelineTransactionType}`,
                method: 'get',
            });
          
            setTransType(response);
        }
        catch (e) {
            console.log(e, 'Error Fetching the  view data')

        };
    };
    
    const GetcontactCompany = async (Id) => {
       
        try {
            const response = await sbaAxios({
                url: `${getPipelineCompanyContact}`,
                method: 'get',
            });
            const companyRespose = await sbaAxios({
                url: getContacts,
                params:{
                    type:""
                },
                method:'get',
            })
            const typedata = response.filter(value => value.ContactTypeId === 1);
            const companycontactdata = typedata.map(item => {
                return {
                    ContactId: item.ContactId,
                    DisplayName: item.ContactName
                };
            });
            setContactCompany(companycontactdata);
            setContactCompanydata(Id === 1 ? typedata : companycontactdata.map(item => ({
                ...item,
                ContactSource:""
            })));
            
        }
        catch (e) {
            console.log(e, 'Error Fetching the  view data')

        };
    };
    const getOwners = async () => {
        try {
            const response = await sbaAxios({
                url: `${getPipelineOwners}`,
                method: 'get',
            });

            if (response) {
                const owners = response?.map(item => ({
                    UserId: item.UserId,
                    FullName: item.Fullname
                }));
                setUsers(owners);
            } else {
                setUsers([]);
                //setUserdata([]);
            }
        } catch (error) {
            console.error('Error fetching owners:', error);
           // setUserdata([]);
        }
    };


    const transTypedropdownchange = (e) => {
       
        SetOpportunitiesData(value => ({ ...value, PipelineTransactionTypeId: e.value.PipelineTransactionTypeId, PipelineTransactionTypeName: e.value.PipelineTransactionTypeName}))
      };
      const contactcompanyddchange = (e) => {
          const contactSourcedata = ContactCompanydata.filter(value => selectedOption === "Contact" ? value.ContactId === e.value.ContactId : value.ContactId ===  e.value.ContactId);
      
        SetOpportunitiesData(value => ({ ...value, ContactId: e.value.ContactId, ContactCompanyName: e.value.DisplayName,ContactSource: contactSourcedata[0].ContactSource}))
      };
    
      const sbaOwnerddchange = (e) => {
          SetOpportunitiesData(value => ({ ...value, OwnerUserId: e.value.UserId, OwnerFullName: e.value.FullName}));
      };
      const probabilityddchange = (e) => {
       
        SetOpportunitiesData(value => ({ ...value, PipelineProbabilityId: e.value.PipelineProbabilityId, PipelineProbabilityName: e.value.PipelineProbilityName}));
      };
      const statusddchange = (e) => {
        
        SetOpportunitiesData(value => ({ ...value, PipelineStatusId: e.value.PipelineStatusId, PipelineStatusName: e.value.PipelineStatusName}));
      };
      const stageddchange = (e) => {
       
        SetOpportunitiesData(value => ({ ...value, PipelineStageId: e.value.PipelineStageId, PipelineStageName: e.value.PipelineStageName}));
      };
      const typeddchange = (e) => {
        
        SetOpportunitiesData(value => ({ ...value, PipelineTypeId: e.value.PipelineTypeId, PipelineTypeName: e.value.PipelineTypeName}));
      };
      const additionalOpportunityddchange = (e) => {
       const additival=e.value.AdditionalOpportunity==="Yes"?true:false
        SetOpportunitiesData(value => ({ ...value, IsAdditionalOpportunity: additival,}));
      };
      const Insuranceddchange = (e) => {
        const insval=e.value.Insurance==="Yes"?true:false
        SetOpportunitiesData(value => ({ ...value, IsInsurance: insval}));
        
      };
      const Sizeddchange = (e) => {
      
        SetOpportunitiesData(value => ({ ...value,PipelineSizeId: e.value.PipelineSizeId, PipelineSizeName: e.value.PipelineSizeName}));
      };
      const contactSourceChange = (event) => {
        SetOpportunitiesData(value => ({ ...value, ContactSource: event.value.leadSourceId}));
      };
      const commentsChange = (event) => {
       
        SetOpportunitiesData(value => ({ ...value, Comments: event.target.value}));
      };
      const dateChange = (newDate) => {
       
        SetOpportunitiesData(value => ({ ...value, PipelineDate: newDate}));
      };
      const communicationdateChange = (newDate) => {
       
        SetOpportunitiesData(value => ({ ...value, CommunicationDate: newDate}));
      };
      const estimatedCloseDateChange = (newDate) => {
       
        SetOpportunitiesData(value => ({ ...value, EstimatedCloseDate: newDate}));
      };
      const handleRadioChange = (event) => {
        setSelectedRadioOption(event.target.value);
        SetOpportunitiesData(value => ({ ...value, ContactId: 0, ContactCompanyName: "--- Please Select ---",ContactSource: ""}))
        if(event.target.value==="Contact")
        {
     GetcontactCompany (1); 

        }
        else
        GetcontactCompany (2); 
      };
      const maxValueChange= (e) => {
        SetOpportunitiesData(value => ({ ...value, MaxAmount: e.target.value}));
        
      };
      const minValueChange = (e) => {
        SetOpportunitiesData(value => ({ ...value, MinAmount: e.target.value}));
      };

  
      const InsertorUpdateOpportunities=(Mode)=>
      {       
          let ifsave = true;
           const pldata=  {
            "pipelineId": opportunitiesData.PipelineId || 0,
            "contactId": opportunitiesData.ContactId,
            "pipelineStatusId": opportunitiesData.PipelineStatusId,
            "pipelineProbabilityId": opportunitiesData.PipelineProbabilityId,
            "pipelineTransactionTypeId": opportunitiesData.PipelineTransactionTypeId,
            "contactSource": opportunitiesData.ContactSource,
            "minAmount": parseFloat(opportunitiesData.MinAmount),
            "maxAmount": parseFloat(opportunitiesData.MaxAmount),
            "pipelineDate": opportunitiesData.PipelineDate || new Date(),
            "comments": opportunitiesData.Comments,
            "createdById": 0,
            "createdDate": new Date(),
            "ownerUserId": opportunitiesData.OwnerUserId,
            "communicationDate": opportunitiesData.CommunicationDate|| null,
            "pipelineStageId": opportunitiesData.PipelineStageId,
            "pipelineTypeId": opportunitiesData.PipelineTypeId,
            "isAdditionalOpportunity": opportunitiesData.IsAdditionalOpportunity,
            "isInsurance": opportunitiesData.IsInsurance,
            "pipelineSizeId": opportunitiesData.PipelineSizeId,
              "estimatedCloseDate": opportunitiesData.EstimatedCloseDate || null
          }
          if (opportunitiesData.PipelineTransactionTypeId === 0) {
            ifsave = false;
            SBNotify({ Msg: "Please Select the Transaction Type", type: "error" });
          }
          else if (opportunitiesData.ContactId === 0 || opportunitiesData.ContactId === -1) {
            ifsave = false;
            SBNotify({ Msg: "Please Select the contact/Company", type: "error" });
          }
          else if (opportunitiesData.PipelineProbabilityId=== 0) {
            ifsave = false;
              SBNotify({ Msg: "Please select The Opportunity Status ", type: "error" });
          }
          else if (opportunitiesData.PipelineStatusId=== 0) {
            ifsave = false;
            SBNotify({ Msg: "Please select the Status", type: "error" });
          }
          else if (opportunitiesData.PipelineStageId=== 0) {
            ifsave = false;
            SBNotify({ Msg: "Please select the Stage", type: "error" });
          }
          else if (opportunitiesData.PipelineTypeId=== 0) {
            ifsave = false;
              SBNotify({ Msg: "Please select the Opportunity Type", type: "error" });
          }
          else if (opportunitiesData.PipelineSizeId=== 0) {
            ifsave = false;
            SBNotify({ Msg: "Please select the Size", type: "error" });
          }
          else if (opportunitiesData.OwnerUserId === 0) {
              ifsave = false;
              SBNotify({ Msg: "Please select the Owner", type: "error" });
          }
          else if (opportunitiesData.PipelineDate === 0) {
              ifsave = false;
              SBNotify({ Msg: "Please select the Date", type: "error" });
          }
          if (ifsave) {
            sbaAxios({
              url: `${insertOrUpdatePipeline}`,
              method: "post",
              data: pldata,
            }).then((response) => {
                if (Mode === "Add")
                SBNotify({ Msg: "Opportunities Saved Successfully", type: "success" });
              else
                SBNotify({ Msg: "Opportunities Updated Successfully", type: "success" });
                setOpen(false);              
                
                setRender(val => val + 1);
                
                setSelectedCustomViewData(val => val);
                //GetgridData(plainData)
             
            }).catch((error) => {
              SBNotify({ Msg: "some error  occured", type: "error" });
            });
          }
      }
      const leadSources = [
        { leadSourceId: 'Personal', leadSourceName: 'Personal' },
        { leadSourceId: 'COI', leadSourceName: 'COI' },
        { leadSourceId: 'Event', leadSourceName: 'Event' },
        { leadSourceId: 'Website', leadSourceName: 'Website' },
        { leadSourceId: 'Referral', leadSourceName: 'Referral' },
        { leadSourceId: 'Other', leadSourceName: 'Other' },
      ];
    
    return (
      <SBADrawer
        open={open}
        setOpen={setOpen}
        close={false}
        title={"Insert / Update Opportunity"}
      >
        <div>
          <div className="row  mb-4">
           <div className="col-md-6">
                        <div>
                            <label className="label">
                                Contact <span className="mandatory">*</span>
                            </label>
                            <SBAComboBox
                                className="w-100"
                                data={ContactCompany}
                                textField={"DisplayName"}
                                valueField={"ContactId"}
                                onChange={contactcompanyddchange}
                                value={contactCompanyval}
                                placeholder="Please Select"
                                popupSettings={{ className: "modalDD" }}
                            ></SBAComboBox>
                        </div>

            </div>
            <div className="col-md-6">
                       
                            <div>
                                <label className="label">Date</label> <span className="mandatory">*</span>
                                <SBDatePicker
                                    className="w-100"
                                    id="Date"
                                    value={
                                        opportunitiesData.PipelineDate
                                            ? moment(opportunitiesData.PipelineDate)
                                            : null
                                    }
                                    onChange={dateChange}
                                ></SBDatePicker>
                            
                        </div>
            </div>
          </div>

          <div className="row mb-4">
            <div className="col-md-6">
            <div>
               <label className="label">Owner</label> <span className="mandatory">*</span>
                            <SBAComboBox
                  className="w-100"
                  data={userdata}
                  textField={"FullName"}
                  valueField={"UserId"}
                  popupSettings={{ className: "modalDD" }}
                  value={sbaOwnerval}
                                onChange={sbaOwnerddchange}
                                placeholder="Please Select"
                ></SBAComboBox>
              </div>
                    </div>

              <div className="col-md-6">
                        <div>
                            <label className="label">Last Communication Date</label>
                            <SBDatePicker
                                className="w-100"
                                id="LastCommunicationDate"
                                value={
                                    opportunitiesData.CommunicationDate
                                        ? moment(opportunitiesData.CommunicationDate)
                                        : null
                                }
                                onChange={communicationdateChange}
                            ></SBDatePicker>
                        </div>
                    </div>
          </div>

          <div className="row mb-4">
           
            <div className="col-md-6">
            <div>
                <label className="label">Min Value</label>
                <div className="d-flex gap-2">
                  <SBACurrencyInput
                    className="form-control enableScroll"
                    decimalsLimit={2}
                    value={opportunitiesData.MinAmount}
                    onBlur={(e) => {
                      const parsedValue = parseFloat(e);
                      SetOpportunitiesData((value) => ({
                        ...value,
                        MinAmount: parsedValue,
                      }));
                    }}
                  />
                </div>
              </div>
                    </div>
                    <div className="col-md-6">
                        <div>
                            <label className="label">Max Value</label>
                            <div className="d-flex gap-2">
                                <SBACurrencyInput
                                    className="form-control enableScroll"
                                    decimalsLimit={2}
                                    value={opportunitiesData.MaxAmount}
                                    onBlur={(e) => {
                                        const parsedValue = parseFloat(e);
                                        SetOpportunitiesData((value) => ({
                                            ...value,
                                            MaxAmount: parsedValue,
                                        }));
                                    }}
                                />
                            </div>
                            {/*  <input type="number" className="form-control enableScroll" onChange={maxValueChange} Value={opportunitiesData.MaxAmount ? opportunitiesData.MaxAmount.toFixed(2):'0.00'}></input>*/}
                        </div>
                    </div>
          </div>

          <div className="row mb-4">
            <div className="col-md-6">
            <div>
                <label className="label">
                Opportunity Status<span className="mandatory">*</span>
                </label>
                            <SBAComboBox
                  className="w-100"
                  data={probabilityData}
                  textField={"PipelineProbilityName"}
                  valueField={"PipelineProbabilityId"}
                  popupSettings={{ className: "modalDD" }}
                  value={probabilityval}
                                onChange={probabilityddchange}
                                placeholder="Please Select"
                ></SBAComboBox>
              </div>
                    </div>
            <div className="col-md-6">
                        <div>
                            <label className="label">
                                Status<span className="mandatory">*</span>
                            </label>
                            <SBAComboBox
                                className="w-100"
                                popupSettings={{ className: "modalDD" }}
                                textField={"PipelineStatusName"}
                                valueField={"PipelineStatusId"}
                                data={statusData}
                                value={statusval}
                                onChange={statusddchange}
                                placeholder="Please Select"
                            ></SBAComboBox>
                        </div>
                    </div>
          </div>

          <div className="row mb-4">
            <div className="col-md-6">
            <div>
                <label className="label">
                  Stage<span className="mandatory">*</span>
                </label>
                            <SBAComboBox
                  className="w-100"
                  data={stageData}
                  textField={"PipelineStageName"}
                  valueField={"PipelineStageId"}
                  value={stageval}
                                onChange={stageddchange}
                                placeholder="Please Select"
                  popupSettings={{ className: "modalDD" }}
                ></SBAComboBox>
              </div>
                    </div>
            <div className="col-md-6">
                        <div>
                            <label className="label">
                                Opportunity Type<span className="mandatory">*</span>
                            </label>
                            <SBAComboBox
                                className="w-100"
                                data={typeData}
                                textField={"PipelineTypeName"}
                                valueField={"PipelineTypeId"}
                                value={typeval}
                                onChange={typeddchange}
                                popupSettings={{ className: "modalDD" }}
                                placeholder="Please Select"
                            ></SBAComboBox>
                        </div>
                    </div>
          </div>

          <div className="row mb-4">
            <div className="col-md-6">
                        <div>
                            <label className="label">
                                Size<span className="mandatory">*</span>
                            </label>
                            <SBAComboBox
                                className="w-100"
                                data={sizeData}
                                textField={"PipelineSizeName"}
                                valueField={"PipelineSizeId"}
                                value={sizeval}
                                placeholder="Please Select"
                                onChange={Sizeddchange}
                                popupSettings={{ className: "modalDD" }}
                            ></SBAComboBox>
                        </div>
                    </div>
            <div className="col-md-6">
                        <div>
                            <label className="label">Lead Source</label>
                            <SBAComboBox
                                className="w-100"
                                data={leadSources}
                                textField={"leadSourceName"}
                                valueField={"leadSourceId"}
                                value={leadSourceValue}
                                onChange={contactSourceChange}
                                placeholder="Please Select"
                                popupSettings={{ className: "modalDD" }}
                            ></SBAComboBox>
                        </div>
                    </div>
          </div>
          
          <div className="row mb-4">
            <div className="col-md-6">
            <div>
                <label className="label">Estimated Close Date</label>
                <SBDatePicker
                  className="w-100"
                  id="EstimatedCloseDate"
                  value={
                    opportunitiesData.EstimatedCloseDate
                      ? moment(opportunitiesData.EstimatedCloseDate)
                      : null
                  }
                  onChange={estimatedCloseDateChange}
                ></SBDatePicker>
              </div>
            </div>
          </div>
          <div className="row ">
            <div className="col-md-12">
              <div>
                <label className="label">Comments</label>
                <input
                  className="w-300 input-default form-control"
                  type="text"
                  onChange={commentsChange}
                  Value={opportunitiesData.Comments}
                />
              </div>
            </div>
          </div>
          <div className="m-1 d-flex justify-content-end mt-2">
            <button className="s-sm-btn mx-1" onClick={() => setOpen(false)}>
              Cancel
            </button>

            <button
              className="p-sm-btn mx-1"
              onClick={() => InsertorUpdateOpportunities(mode)}
            >
              Save
            </button>
          </div>
        </div>
      </SBADrawer>
    );

   
  };
  const NotesPopUp=({documents,notes,summary})=>{

    const pdfview = (documentId, documentExtension) => {

        try {
            if (documentExtension === ".pdf") {
                const encodedDocumentId = btoa(documentId.toString());
                const urls = DownloadDocument + encodedDocumentId;
                sbaAxios({
                    url: urls,
                }).then((response) => {
                    window.open(urls);

                });              
            } else if (
                documentExtension === ".xlsx" ||
                documentExtension === ".xls"
            ) {
                const encodedDocumentId = btoa(documentId.toString());
                const urls = DownloadDocument + encodedDocumentId;
                sbaAxios({
                    url: urls,
                }).then((response) => {
                    window.open(urls);

                });   
            } else if (
                documentExtension === ".png" ||
                documentExtension === ".jpg" ||
                documentExtension === ".jpeg" ||
                documentExtension === ".gif"
            ) {
                const encodedDocumentId = btoa(documentId.toString());
                const urls = DownloadDocument + encodedDocumentId;
                sbaAxios({
                    url: urls,
                }).then((response) => {
                    window.open(urls);

                });
            }
            else if (
                documentExtension === ".doc" || documentExtension === ".docx"
            ) {
                const encodedDocumentId = btoa(documentId.toString());
                const urls = DownloadDocument + encodedDocumentId;
                sbaAxios({
                    url: urls,
                }).then((response) => {
                    window.open(urls);

                });
            }
            else if (
                documentExtension === ".ppt" || documentExtension === ".pptx"
            ) {
                const encodedDocumentId = btoa(documentId.toString());
                const urls = DownloadDocument + encodedDocumentId;
                sbaAxios({
                    url: urls,  
                }).then((response) => {
                    window.open(urls);

                });
            }
        } catch (error) {
            console.error("Error opening document:", error);
        }
    };
    return (
      <>
     
          <div class="card-body p-0">
          <div className='row my-2'>
            <div className='col-md-4'> <div className='fw-medium'>From :</div><div className='fw-medium'>{notes?.EmailFrom}</div></div>
        </div>
        <div className='row my-2'>
        <div className='col-md-4'><div className='fw-medium'>To  :</div><div className='fw-medium'>{notes?.EmailTo}</div></div>
        </div>
        <div className='row my-2'>
        <div className='col-md-4'><div className='fw-medium'>CC :</div><div className='fw-medium'>{notes?.EmailCc}</div></div>
       </div>
       <div className='row my-2'>
        <div className='col-md-4'><div className='fw-medium'>Subject :</div><div className='fw-medium'>{notes?.EmailSubject}</div></div>
          </div>
          </div>
          <div class="row p-3 border-bottom  m-0"> </div>
          { documents.length===0 ? <label>No Documents Available </label> :
      documents.map(item=>{
        return (
          <div class="card-body p-0">
            <div class="row p-3 border-bottom  m-0">
              <div class="col-11 left">
              <div> <Link   onClick={() =>pdfview(item.DocumentId,item.DocumentExtension)} >{item.DocumentName}</Link></div>
              </div>
              {
                <div class="col-1 text-sm-end fw-medium">
                  <span className='SBA_hand'>{item.DocumentExtension == ".pdf" ? <i class="far fa-file-pdf" style={{ color: "red" }}></i> : ""} </span>
                </div>
              }
            </div>
          </div>

        );
      })
      }
        
     <div className='row my-2'>
     <div className='fw-medium '>Body :</div>
        <div className='detail p-2' id='notesTabContent' style={{ overflowY: 'scroll', height: "50vh" }} dangerouslySetInnerHTML={{ __html: summary?.ActivityDescriptionHtml }}></div>
        </div>
       
      </>
    )
   
  }
  const ContactNotes = ({ notes }) => {
const [showNotes,setShowNotes]=useState(false);
const[activityDocuments,setActivityDocuments]=useState([]);
const[activityDetails,setActivitydetails]=useState();
const[activitySummary, setActivitySummary] = useState(null);
    const columnDefs = [
        
        { 
            tooltipField: 'ActivityType',
            field: "ActivityType", headerName: "Activity Type" },
        { 
          tooltipField: 'ActivityName',
          field: "ActivityName", headerName: "Activity Subject" },
    
          {
            tooltipField: 'ActivityDate',
            field: "ActivityDate", headerName: "Activity Date",
           
            maxWidth: 125,
            valueFormatter: function (params) {
              return moment(params.value).format('MM/DD/YYYY');
            }
          },
      ];
      const gridOptions = {
        defaultColDef: {
           resizable: true,
           sortable: true,
            filter: true,
            flex:1
        },
       rowHeight: 30,
        
    };
    const handleRowDoubleClicked = (row) => {
        try {
            setShowNotes(true);
            const activityId = row.data.ActivityId;
            getActivityDetaisl(activityId)
            
        } catch (error) {
            console.error("Error opening document:", error);
        }
    };
    const getActivityDetaisl= async (id)=>
    {
        try {
            const response =  await sbaAxios({
                url: `${getActivityDetails}${id},${2}`,
                method: 'get',
            });
            const data = response;
            setActivitydetails(data.ActivityDetails);
           setActivityDocuments(data.ActivityDocuments);
           setActivitySummary(data.ActivitySummary);
           
         
        } catch (error) {
            console.error("Error fetching entities from API:", error);
        }
    }
    return(
        <> <div>
        <div className="ag-theme-alpine pt-0 mx-2"  style={{ width: '100%', height: '300px' }}>
        <AgGridReact
          columnDefs={columnDefs}
          rowData={notes}
         gridOptions={gridOptions}
         defaultColDef={{resizable:true}}
     
         onRowDoubleClicked={handleRowDoubleClicked}
        />
        </div>
        </div>
        <Modal
            show={showNotes}
            onHide={()=>setShowNotes(false)}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
        
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-scrollable w-100 " >
                <div class="modal-content p-2 overflow-auto " >
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="DocumentsModalLabel">Activity Details
                        </h1>
                        <button type="button" class="btn-close" onClick={()=>setShowNotes(false)}
                            aria-label="Close"></button>
                    </div>
                    <form action="#">
                        <div class="modal-body ">
                            <h6 class="fw-medium fs-6 mt-3">
                              
                            </h6>
                            <NotesPopUp documents={activityDocuments} details={activityDetails} summary={activitySummary}></NotesPopUp>
                        </div>
                    </form>
                </div>
            
           
        </div>
        </Modal>
        </>

        
    )

   
  };

  const DeleteConfirmationModal = ({ open, setOpen, pipelineId,setRender,setSelectedCustomViewData }) => {
    const DeletePipeline =  () => {
        sbaAxios({ url: `${deletePipeline}${pipelineId}` })
        .then((res) => {
            setOpen(false);
            setSelectedCustomViewData(val=>val);
            setRender(val=>val+1);
          
          SBNotify({
            Msg: "Opportunity Deleted Successfully",
            type: "success",
          });
          
        })
        .catch((error) => {
          SBNotify({ Msg: error, type: "error" });
        });
       
    
       
    
      };
    return <Modal show={open}>
      <Modal.Header
        closeButton
        onClick={() => {
          setOpen(false);
        }}
      >
        <Modal.Title>
        Delete Opportunity 
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Opportunity will be deleted permanently. Are you sure?</p>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="s-sm-btn mx-1"
          onClick={() => { setOpen(false)}}
        >
          Cancel
        </button>
        <button
          className="p-sm-btn mx-1"
          onClick={DeletePipeline }
        >
          Yes
        </button>
      </Modal.Footer>
    </Modal>
  };
  